export class ConfigDB {
	static data = {
		settings: {
			layout_type: 'ltr',
			layout_version: 'light',
		}
	}
}

